export default "__VITE_ASSET__eN$yTMJu__"